import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import SvgsOthers from "@/components/svgs/others";
import News from "@/components/News/index";
import { newPath } from '@/utils/index'
import { TopInfo, NewsList } from './utils'
import { DetailRoot } from './css'

const Index = ({ store }) => {
  const { isMobile } = store.common;
  const history = useHistory();
  const { id } = useParams();

  const [navIndex, setNavIndex] = useState(0)
  const fData = NewsList.filter((item) => item.id == id)
  if (id != TopInfo.id && !fData.length) {
    console.error(`Cannot find the id ${id}`)
    history.push(`${newPath}/news`)
    return null
  }
  
  const data = id == TopInfo.id ? TopInfo : fData[0]
  Array.isArray(data.content) && (data.content = data.content.map((item, index) => {
    const _item = typeof item === 'object' ? item : { text: item }
    _item.index = index
    return _item
  }))
  const navs = Array.isArray(data.content) ? data.content.filter((item) => typeof item === 'object' && item.nav) : []
  const switchNav = (index) => () => {
    setNavIndex(index)
    const target = document.querySelector(`#__content_${index}`)
    target && target.scrollIntoView && target.scrollIntoView({ behavior: "smooth", block: 'center' })
  }

  return (
    <DetailRoot className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[0].name} />
      <div className="center">
        <div className="breadcrumbs">
          <a onClick={() => history.push(`${newPath}/`)}>Home</a>/<a onClick={() => history.push(`${newPath}/news`)}>News</a>/<span>News Detail</span>
        </div>
        <div className="main">
          <div className="main-wrapper">
            <div className="top">
              <div className="pic">
                <img src={data.thumb} alt="" />
              </div>
              <div className="detail">
                <h1>{data.title}</h1>
                <div className="info">
                  <div className="user">
                    {data.ava && <img src={data.ava} height={14} />}
                    {data.name}
                  </div>
                  <span className="line"></span>
                  <span>{data.date}</span>
                </div>
              </div>
            </div>
            <div className="content">
              {data.content.map(({ text, index }, key) => {
                return <p key={index} id={`__content_${index}`} dangerouslySetInnerHTML={{ __html: text}}></p>
              })}
            </div>
          </div>
          <div className="navs">
            <ul>
              {navs.map(({ nav, index }) => (
                <li className={`${navIndex === index ? 'on' : ''}`} onClick={switchNav(index)} key={index}>{nav}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="center">
          <Contact />
          <Footer />
        </div>
      </div>
    </DetailRoot>
  )
}

export default withRouter(inject("store")(observer(Index)))